import React, { useState } from "react";
import Approval from "../../assets/svg/Approval";
import { useNavigate } from "react-router-dom";
const steps = [
  {
    id: 1,
    title: "Add Payout details",
    description: "Add your bank details to receive payments.",
    key: "bank",
  },
  {
    id: 2,
    title: "Create your listings",
    description: "Add your event services so clients can find and book you.",
    key: "listing",
  },
  {
    id: 3,
    title: "Get Verified",
    description: "Submit your business permit for verification.",
    key: "has_docs",
  },
];

export const ToolTracker = ({ handleClose, bank_info, merchant }) => {
  const progress = {
    has_docs: merchant?.has_docs === "1",
    bank: bank_info?.bank_name && bank_info?.bank_name !== "",
    listing: merchant?.has_listing === "1" && merchant?.status !== "1",
  };
  const getProgress = () => {
    // Default progress
    let progress = 0;

    // Step 1: Bank (required)
    if (bank_info?.bank_name && bank_info?.bank_name !== "") {
      progress = 33;

      //  Step 1: Listing (required)
      if (merchant?.has_listing === "1" && merchant?.status !== "1") {
        progress = 66;

        // Step 3: Docs
        if (merchant?.has_docs === "1") {
          progress = 100;
        }
      }
    }

    return progress;
  };

  const navigate = useNavigate();
  const handleSubmit = () => {
    navigate("/account/personal");
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-xs">
      <div className="bg-white rounded-xl max-w-md w-full relative overflow-y-auto max-h-[90vh]">
        {merchant?.has_docs === "0" && (
          <div className="flex flex-row space-x-4 mb-4">
            <div className="merchant-started justify-between items-center space-x-4  hover:bg-opacity-20 flex flex-row flex-1 rounded-t-xl">
              <div className="flex p-6 flex-col w-full">
                <div className="font-semibold text-base lg:text-lg text-white">
                  Getting Started!
                </div>
                <div
                  style={{ background: "#4F4181" }}
                  className="mt-2 w-full rounded-full h-2 overflow-hidden"
                >
                  <div
                    className="h-2 rounded-full bg-sunrise-600 transition-all duration-500"
                    style={{ width: `${getProgress()}%` }}
                  />
                </div>
                <div className="mt-2 font-semibold text-xs lg:text-sm text-white">
                  {getProgress()}%{" "}
                  {getProgress() < 66
                    ? "Complete"
                    : getProgress() === 66
                    ? "Almost there!"
                    : "All set!"}
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="flex flex-col px-6 pt-4">
          <div className="flex flex-col">
            {steps.map((step, index) => {
              const isDone = progress[step.key];
              const isLast = index === steps.length - 1;

              return (
                <div key={step.id} className="flex">
                  <div className="flex flex-col items-center mr-4">
                    <div
                      className={`flex items-center justify-center w-6 h-6 rounded-full border-2 ${
                        isDone
                          ? "border-sunrise-500 text-white"
                          : "border-sunrise-500 text-sunrise-500"
                      }`}
                    >
                      {isDone ? (
                        <svg
                          width="20"
                          height="21"
                          viewBox="0 0 20 21"
                          fill="none"
                        >
                          <path
                            d="M8.6 12.3L6.45 10.15C6.26667 9.96667 6.03333 9.875 5.75 9.875C5.46667 9.875 5.23333 9.96667 5.05 10.15C4.86667 10.3333 4.775 10.5667 4.775 10.85C4.775 11.1333 4.86667 11.3667 5.05 11.55L7.9 14.4C8.1 14.6 8.33333 14.7 8.6 14.7C8.86667 14.7 9.1 14.6 9.3 14.4L14.95 8.75C15.1333 8.56667 15.225 8.33333 15.225 8.05C15.225 7.76667 15.1333 7.53333 14.95 7.35C14.7667 7.16667 14.5333 7.075 14.25 7.075C13.9667 7.075 13.7333 7.16667 13.55 7.35L8.6 12.3ZM10 20.5C8.61667 20.5 7.31667 20.2375 6.1 19.7125C4.88333 19.1875 3.825 18.475 2.925 17.575C2.025 16.675 1.3125 15.6167 0.7875 14.4C0.2625 13.1833 0 11.8833 0 10.5C0 9.11667 0.2625 7.81667 0.7875 6.6C1.3125 5.38333 2.025 4.325 2.925 3.425C3.825 2.525 4.88333 1.8125 6.1 1.2875C7.31667 0.7625 8.61667 0.5 10 0.5C11.3833 0.5 12.6833 0.7625 13.9 1.2875C15.1167 1.8125 16.175 2.525 17.075 3.425C17.975 4.325 18.6875 5.38333 19.2125 6.6C19.7375 7.81667 20 9.11667 20 10.5C20 11.8833 19.7375 13.1833 19.2125 14.4C18.6875 15.6167 17.975 16.675 17.075 17.575C16.175 18.475 15.1167 19.1875 13.9 19.7125C12.6833 20.2375 11.3833 20.5 10 20.5Z"
                            fill="#F67376"
                          />
                        </svg>
                      ) : (
                        <span className="text-xs">{step.id}</span>
                      )}
                    </div>
                    {!isLast && (
                      <div className="w-[2px] flex-1 bg-sunrise-500" />
                    )}
                  </div>

                  <div className="pb-6">
                    <div className="text-sm lg:text-base font-semibold text-gray-550">
                      {step.title}
                    </div>
                    <div className="text-xs lg:text-sm text-gray-350">
                      {step.description}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="flex justify-center space-x-2 px-6 pb-6 pt-4">
          <button
            className="w-1/3 py-3 rounded-xl bg-primary-500 text-white font-semibold hover:opacity-90"
            onClick={handleClose}
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};
